module.exports = "<div class=\"graph-box-wrapper\" data-ng-style=\"$ctrl.wrapperStyle\">\n    <div class=\"graph-box\">\n        <canvas id=\"chart\" class=\"chart chart-bar\" data-ng-style=\"$ctrl.boxStyle\" height=\"400\" width=\"450\" chart-options=\"$ctrl.options\" chart-data=\"$ctrl.data.data\"\n            chart-series=\"$ctrl.data.series\" chart-labels=\"$ctrl.xlabels\" chart-dataset-override=\"$ctrl.data.override\">\n        </canvas>\n    </div>\n    <div class=\"legend-container\" data-ng-style=\"$ctrl.legendStyle\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/newDashBoard/components/graphs/grouped/grouped.html
// module id = 1752
// module chunks = 0